import {getheaders} from "./authService";


export async function getMyJobs(startDate, endDate) {
    let requestOptions = {
        method: 'GET', headers: getheaders(), redirect: 'follow'
    };
    return fetch("/goapi/worker/myjob?start_date=" + startDate + "&end_date=" + endDate, requestOptions)
}

export async function getMyJobsDates(date) {
    const formattedDate = date.toISOString().slice(0, 10);

    let requestOptions = {
        method: 'GET', headers: getheaders(), redirect: 'follow'
    };
    return fetch(`/goapi/worker/myjobdate?date=${formattedDate}`, requestOptions)
}

export async function getJobNotes(cosjobid) {
    let requestOptions = {
        method: 'GET', headers: getheaders(), redirect: 'follow'
    };
    return fetch("/api/jobnote/" + cosjobid, requestOptions)
}

export async function changeStatus(jobId, status) {
    let reqbody = {
        "status": status, "cos_job_id": jobId,
    }
    let requestOptions = {
        method: 'PUT', headers: getheaders(), redirect: 'follow', body: JSON.stringify(reqbody)
    };
    return fetch("/api/worker/myjob/status", requestOptions)
}

export async function addJobNotes(cosjobid, notes) {
    let requestOptions = {
        method: 'POST', headers: getheaders(), redirect: 'follow',
        body: JSON.stringify({
            "id": cosjobid,
            "note": notes
        })
    };
    return fetch("/api/jobnote", requestOptions)
}
